// From backend
export const CATEGORY_TYPES = [
    'calendar',
    'contacts',
    'messaging',
    'social',
    'email',
    'search',
    'files',
    'groups',
    'faq',
    'crm',
    'ticket',
    'rooms',
    'video',
    'ats',
    'payment'
] as const;

export type ProviderType = typeof CATEGORY_TYPES[number];

// From backend
export interface IProviderState {
    loading?: boolean;
    count?: number;
    dateLastImport?: string;
    default?: boolean; // for new accounts, default is not set
    [path: string]: any;
}

// From backend
export interface IProvider {
    id: string;
    userId: string;
    orgId?: string;
    categoryType: string[];
    providerType: string;
    name: string;
    dateLastImport: Date | string;
    auth?: any;
    calendar?: IProviderState & { reimport?: string };
    contacts?: IProviderState;
    faq: any;
    mail?: IProviderState;
    rooms: any;
    xref: string;
    error?: string;
    errorDate?: Date;
    email?: string; // this is references in legacy code, so old accounts may have an email field
}

export const calendarProvidersThatAlwaysSendUpdates = ['microsoft graph', 'exchange graph'];
